import Constants from '../../../utils/Constants';
import buildImg from '../../../assets/imgs/advantage/build.webp';
import garageImg from '../../../assets/imgs/advantage/garage.webp';
import interiorImg from '../../../assets/imgs/advantage/interior.webp';

const Advantage = () => {
  return (
    <div id={Constants.ADVANTAGE} className='advantage'>
      <div className='advantage_container container'>
        <h2 data-aos='fade-up' className='text_center'>
          PREDNOSTI
        </h2>
        <div className='advantage_container_section'>
          <div
            data-aos='fade-left'
            data-aos-delay='50'
            className='advantage_container_section_card'
          >
            <div className='advantage_container_section_card_img'>
              <img src={buildImg} alt='podzemni parking' />
            </div>
            <h3>VRHUNSKA GRADNJA</h3>
            <p>
              Osnovna konstrukcija objekata je armirano-betonska, s toplinski i
              zvučno izoliranom ETICS fasadom (10 cm kamene vune), dok je krovna
              fasada zaštićena kvalitetnom hidro-izolacijskom membranom.
            </p>
          </div>
          <div
            data-aos='fade-left'
            data-aos-delay='150'
            className='advantage_container_section_card'
          >
            <div className='advantage_container_section_card_img'>
              <img src={interiorImg} alt='kvalitetna gradnja' />
            </div>
            <h3>VRUNSKI INTERIJER</h3>
            <p>
              Stanovi su opremljeni s vrhunskim parketom, sanitarijama i
              pločicama, protupožarnim vratima, modernim sobnim vratima i PVC
              zatvorima. U svaki stan je ugrađen vrhunski klima urešaj i video
              parlafon u boji.
            </p>
          </div>
          <div
            data-aos='fade-left'
            data-aos-delay='250'
            className='advantage_container_section_card'
          >
            <div className='advantage_container_section_card_img'>
              <img src={garageImg} alt='uređeni okoliš' />
            </div>
            <h3>PODZEMNI PARKING</h3>
            <p>
              Obe zgrade imaju podzemni parking na dvije etaže sa 151 garažnim
              box-om. Svaki garažni box ima svoj daljinski s rolo vratima.
              Garaža je povezana sa stambenim dijelom preko lifta.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Advantage;
